import { AuthApiPath, CONTENT_TYPE_FORM } from "@/lib/auth/constants";
import * as QueryString from "querystring";
import { requestAndBindCsrfToHeaders } from "@/lib/auth/requestAndBindCsrfToHeaders";
import { buildApiEndpoint } from "@/lib/auth/buildApiEndpoint";
import newrelic from "@/lib/monitoring/newrelic";

export interface ValidateTokenResponse {
  is_valid: boolean;
  [key: string]: any;
}

/**
 * Validate a password reset token with the LMS
 * @param token The password reset token to validate
 */
export default async function validateToken(
  token: string,
): Promise<ValidateTokenResponse> {
  const startTime = Date.now();
  const url = buildApiEndpoint(AuthApiPath.PasswordResetTokenValidate);
  const headers = await requestAndBindCsrfToHeaders({
    "Content-Type": CONTENT_TYPE_FORM,
  });
  const body = QueryString.stringify({ token });

  const res = await fetch(url, {
    method: "POST",
    headers: headers,
    body,
    credentials: "include",
  });
  const responseTime = Date.now() - startTime;

  if (!res.ok) {
    newrelic.noticeError(new Error(`Password reset failed: ${res.status}`), {
      submodule: "auth",
      endpoint: "PasswordReset",
      status: res.status,
      errorMessage: "Password reset failed",
      responseTime: responseTime,
      hasToken: !!token,
      isAccountRecovery: false, // This is not an account recovery flow
      timestamp: new Date().toISOString(),
    });
    throw new Error(`Token validation failed: ${res.status}`);
  }
  return res.json();
}
